<template>
  <div class="resource">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div v-if="pageData.id || loading" v-loading="loading" class="table-agile-info">
            <div class="common-new-title mode2">
              <span>考培日语考级订单</span>
            </div>
            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">订单编号：</label>
                <span>{{ pageData.big_order_no }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">订单名称：</label>
                <span>{{ pageData.title }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">创建时间：</label>
                <span>{{ pageData.create_time }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">APP用户ID：</label>
                <span>{{ pageData.uid }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">APP用户名：</label>
                <span>{{ pageData.pub_account }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">学生编号：</label>
                <span>{{ pageData.pub_userid }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">学生姓名：</label>
                <span>{{ pageData.username }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">电话号：</label>
                <span>{{ pageData.tel }}</span>
              </div>
              <div class="box-content box-content-double">
                <label class="form-tit">订单备注：</label>
                <span>{{ pageData.memo }}</span>
              </div>
            </div>
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>商品目录</span>
            </div>
            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">商品类型：</label>
                <span>{{ pageData.goods_type }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">商品名称：</label>
                <span>{{ pageData.title }}</span>
              </div>
              <div class="box-content">
                <label class="form-tit">应付金额：</label>
                <span>{{ pageData.price }}</span>
              </div>
            </div>
            <!--列表部分 end-->
            <!--报账列表部分 start -->
            <div class="common-new-title mode2">
              <span>支付记录</span>
            </div>
            <jm-tableList
              :url="getListurl"
              :search-data="searchData"
            >
              <el-table-column slot="confirm_time" label="到账日期">
                <a slot-scope="scope" @click="editConfirmTime(scope.row)">
                  {{ scope.row.confirm_time }}
                </a>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                fixed="right"
                align="center"
                header-align="center"
                width="150"
                label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    :loading="loading"
                    @click="openAccountDialog(scope.row)"
                    size="small">报账文本</el-button>
                  <el-button
                    v-if="$hasPermission(171)"
                    type="primary"
                    v-show="Number(scope.row.finance_status) === 0 || Number(scope.row.finance_status) === 1"
                    @click="confirmTrade(scope.row)"
                    size="small">到账确认</el-button>
                  <el-button
                    v-if="$hasPermission(171)"
                    type="danger"
                    :loading="loading"
                    v-show="Number(scope.row.finance_status) === 0"
                    @click="refuseTrade(scope.row)"
                    size="small">拒绝</el-button>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--报账列表部分 end-->
            <!--到账确认弹窗 start-->
            <el-dialog
              :title="onlyUpdateConfirmTime ? '修改到账日期' : '到账确认'"
              :visible.sync="dialogConfirmLock"
              width="600px"
              :show-close="false">
              <el-form label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="到账日期：">
                      <el-date-picker
                        v-model="confirmTime"
                        type="date"
                        value-format="timestamp"
                        placeholder="选择到账日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="dialogClose(3)">取 消</el-button>
                <el-button type="primary" :loading="loading" :disabled="!confirmTime" @click="saveConfirmDialog">确 定</el-button>
              </span>
            </el-dialog>
            <!--到账确认弹窗 start-->
            <!--拒绝弹窗 start-->
            <el-dialog
              title="拒绝信息"
              :visible.sync="dialogRefuseLock"
              width="600px"
              :show-close="false">
              <el-form label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="财务备注：">
                      <el-input
                        type="textarea"
                        :rows="4"
                        resize="none"
                        placeholder="请输入内容"
                        v-model="refuseText">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="dialogClose(2)">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="saveRefuseTrade">确 定</el-button>
              </span>
            </el-dialog>
            <!--拒绝弹窗 end-->
            <!--报账文本弹窗 start-->
            <el-dialog
              title="报账内容"
              :visible.sync="dialogAccountLock"
              width="600px"
              :show-close="false">
              <div style="white-space: pre-wrap; max-height: 400px; overflow-y: auto" v-html="accountText"></div>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogClose(1)">确 定</el-button>
              </span>
            </el-dialog>
            <!--报账文本弹窗 end-->
          </div>
          <jm-empty v-else :description="loading ? '正在加载中 ...' : '订单数据不存在或者已删除'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import empty from '@/components/common/empty';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      pageData: {
        userInfo: {
          username: ''
        }
      },
      searchData: {
        isOrderDetail: true,
        order_id: this.$route.params.id,
        project_id: 14
      },
      loading: true,
      getListurl: '/finance/trade/pagetable', // 表格数据源
      pageDs: {},
      dialogAccountLock: false, // 报账文本弹窗锁
      dialogRefuseLock: false, // 拒绝报账弹窗锁
      dialogConfirmLock: false, // 到账确认弹窗锁
      accountText: '', // 报账文本弹窗内容
      refuseText: '', // 拒绝弹窗文本
      confirmTime: null, // 到账日期
      onlyUpdateConfirmTime: false, // 只更新时间
      currentRowId: '',
    };
  },
  computed: {},
  methods: {
    async initData(oid) {
      const promiseData = [
        this.$http._post({
          url: 'finance/order/find',
          data: { id: oid, project_id: 14 }
        }),
        this.$http._post({
          url: '/training/trade/searchData'
        })
      ];

      try {
        const values = await Promise.all(promiseData);
        this.pageData = values[0].data;
        this.pageDs = values[1].data;
      } catch (e) {
        console.error('Promise Error');
      }
      this.loading = false;
    },
    // 打开报账文本弹窗
    openAccountDialog(row) {
      this.dialogAccountLock = true;
      this.accountText = row.trade_text;
    },
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          this.dialogAccountLock = false;
          break;
        case 2:
          this.dialogRefuseLock = false;
          break;
        case 3:
          this.dialogConfirmLock = false;
          break;
        default:
          break;
      }
    },
    // 到账确认
    confirmTrade(row) {
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = false;
    },
    // 修改到账日期
    editConfirmTime(row) {
      this.confirmTime = (new Date(row.confirm_time)).getTime();
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = true;
    },
    // 到账提交保存
    saveConfirmDialog() {
      const url = this.onlyUpdateConfirmTime ? '/finance/trade/saveConfirmTime' : '/finance/trade/financeConfirm';
      const msg = this.onlyUpdateConfirmTime ? '修改到账日期成功' : '报账操作成功';

      this.$http
        ._post({
          url: url,
          data: { id: this.currentRowId, confirmTime: this.confirmTime / 1000 }
        })
        .then(() => {
          this.$message.success(msg);
          this.dialogConfirmLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 拒绝报账打开
    refuseTrade(row) {
      this.currentRowId = row.id;
      this.dialogRefuseLock = true;
    },
    // 拒绝弹窗保存
    saveRefuseTrade() {
      this.$http
        ._post({
          url: '/finance/trade/financeRefuse',
          data: { id: this.currentRowId, message: this.refuseText }
        })
        .then(() => {
          this.$message.success('拒绝完成');
          this.dialogRefuseLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-empty': empty,
    'jm-tableList': tableList
  },
  mounted() {
    this.initData(this.$route.params.id);
  }
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
  .finance-wrap{
    padding: 30px 20px;
    clear: both;
  }
</style>
